import { render, staticRenderFns } from "./ViewAtividadeCliente.vue?vue&type=template&id=82f1e19c"
import script from "./ViewAtividadeCliente.vue?vue&type=script&lang=js"
export * from "./ViewAtividadeCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports